import { useNavigate } from "react-router-dom";
import AlertBox from "../components/alertBox";
import InputField from "../components/inputField";
import MainButton from "../components/mainButton";
import { useState } from "react";
import { userService } from "../services/userService";
import Loading from "../components/loading";
import { FiEye, FiEyeOff } from "react-icons/fi";

const LoginPage: React.FC = () => {
  const [login, setLogin] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const [validate, setValidate] = useState({
    email: false,
    password: false,
  });
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onChangeInputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newLogin: any = { ...login };
    let newValidate: any = { ...validate };
    newLogin[event.target.name] = event.target.value;
    if (event.target.value === "") {
      newValidate[event.target.name] = true;
    } else {
      newValidate[event.target.name] = false;
    }
    setValidate(newValidate);
    setLogin(newLogin);
  };

  const onLogin = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    console.log(login);
    if (login.email === "" || login.password === "") {
      setOpen(!open);
    } else {
      setIsLoading(true);
      userService
        .login(login.email.toLowerCase(), login.password)
        .then((res) => {
          console.log(res);
          localStorage.setItem("user", JSON.stringify({ ...res.user }));
          localStorage.setItem("token", res.token);
          setIsLoading(false);
          navigate("/dashboard");
        })
        .catch((err) => {
          setIsLoading(false);
          setOpen(!open);
          console.log(err);
          setErrMsg(err.response.data.message);
        });
    }
  };

  return (
    <>
      <div className="relative h-screen flex items-center justify-center font-anuphan">
        {isLoading && <Loading />}
        {/* Content */}
        <div className="flex w-4/5 lg:w-2/3 h-4/5 bg-white rounded-xl shadow-lg z-10">
          <div className="lg:w-2/5 lg:flex hidden">
            <img
              src="./login.png"
              alt=""
              className="object-cover h-full rounded-l-xl"
            />
          </div>
          <div className="relative lg:w-3/5 w-full px-8 py-5 flex flex-col items-center">
            <div
              className="absolute inset-0 bg-bottom bg-no-repeat bg-contain -z-10"
              style={{ backgroundImage: "url('/login-form.png')" }}
            ></div>
            <img src="./logo.png" alt="" className="w-24 mt-5" />
            <p className="text-xl fond-bold text-center mt-3">
              <b>Algae Deep Tech</b>
            </p>
            <p className="text-lg fond-bold text-center">Dashboard</p>
            <div className="flex flex-col justify-center gap-y-5 items-center mt-16 w-full">
              <div className="md:w-3/5 w-full">
                <InputField
                  label="email"
                  name="email"
                  type="text"
                  onChangeHandler={onChangeInputHandler}
                />
                <span className="text-xs text-red" hidden={!validate.email}>
                  Please fill email
                </span>
              </div>
              <div className="md:w-3/5 w-full relative">
                <InputField
                  label="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  onChangeHandler={onChangeInputHandler}
                />

                {/* eye icon */}
                <button
                  type="button"
                  className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>

                <span className="text-xs text-red" hidden={!validate.password}>
                  Please fill password
                </span>
              </div>
            </div>
            <div className="mt-12 grid justify-items-center">
              <button type="button" className="w-full cursor-pointer">
                <MainButton
                  label="Sign In"
                  color="bg-dark-green"
                  onClickHandler={(e) => onLogin(e)}
                />
              </button>
              <p className="text-xs text-gray-dark mt-3">
                Copyright@2025 Microcap Dashboard
              </p>
            </div>
          </div>
        </div>
        <AlertBox open={open}>
          <div className="flex flex-col justify-center items-center">
            <div className="text-sm">{errMsg}</div>
            <div className="text-xs w-full mt-3 cursor-pointer">
              <MainButton
                label="ตกลง"
                color="bg-navy"
                onClickHandler={(e) => setOpen(!open)}
              />
            </div>
          </div>
        </AlertBox>

        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/login-bg.png')" }}
        ></div>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-green-light to-navy opacity-70"></div>
      </div>
    </>
  );
};

export default LoginPage;
